import React from 'react'
import styled from "styled-components"
import List from "./list"

const DesignStage = () => {
    return (
        <>
        <Wrapper>
        <div className="center">
            <h2>Design Stage</h2>
            <p>Once we have established our client’s vision and our team is ready to embark, we are ready to begin production. </p>
        </div>
        </Wrapper>
        <List />
        </>
    )
}

const Wrapper = styled.section`
  margin-top: 100px;
  margin-bottom: 20px;
  padding: 26px 20px;
  background: var(--clr-primary-1);
  color: var(--clr-white);
  h2 { font-size: 30px; line-height: 47px; } 
  p { font-size: 12px; line-height: 190%; color: var(--clr-white); }

  @media screen and (min-width: 360px) { padding: 25px 57px; }
  @media screen and (min-width: 768px) { padding: 25px 77px; }
  @media screen and (min-width: 1024px) { margin: 100px 129px; }
  @media screen and (min-width: 1025px) {
    padding: 100px 0;
    padding-bottom: 1px;
    margin: 0;
    .center {
      width: 90vw;
      max-width: 1170px;
      margin: 0px auto;
      h2 { font-size: 46px; line-height: 72px; } 
      p { width: 582px; font-size: 14px; line-height: 190%; text-align: justify; }
      @media (min-width: 1180px) {width: 100%;}
    }
    
  }
`

export default DesignStage
